export enum TipoCNAEEnum {

  SECAO,
  DIVISAO,
  GRUPO,
  CLASSE,
  SUBCLASSE
}
